// File type constants
export const PDF = 'pdf';
export const IMAGE = 'image';

// Placeholder constants
export const EMPTY_PLACEHOLDER = '---';
export const NO_DATA_PLACEHOLDER = 'No data available';

// File size limits
export const MENU_CONFIG_MAX_PDF_SIZE = 50 * 1024 * 1024 + 1;
export const MAX_PDF_SIZE = 10 * 1024 * 1024 + 1;
export const MAX_UPLOADING_IMAGE_SIZE = 10 * 1024 * 1024;
export const MIN_FILE_SIZE = 2 * 1024 * 1024;
export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;

// Time format constants
export const TIME_FORMAT_12_HOUR = 'hh:mm A';
export const TIME_FORMAT_24_HOUR = 'HH:mm';
export const TIME_FORMAT_24_HOUR_WITH_SECONDS = 'HH:mm:ss';
export const TIME_FORMAT_12_HOUR_WITH_SECONDS = 'hh:mm:ss A';

// Date format constants
export const DD_MM_YYYY = 'DD-MM-YYYY';
export const MM_DD_YYYY = 'MM-DD-YYYY';
export const YYYY_MM_DD = 'YYYY-MM-DD';

// Miscellaneous constants
export const PDF_fileType = 'PDF';
export const FREE = 'FREE';
export const CALENDAR = 'calendar';

// Confirmation message for deletion
export const CONFIRM_DELETE_TITLE = 'Are you sure you want to delete';
